import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Vehicle, WdtkEvent } from 'src/app/models/wdtk-event.model';
import { ConfigService } from 'src/app/services/config/config.service';


export enum TypAction {
  SET = 'SET',
  NEW_VEHICLE = 'NEW_VEHICLE',
  DELETE_VEHICLE = 'DELETE_VEHICLE',
  NEW_BUNDLE = 'NEW_BUNDLE',
  DELETE_BUNDLE = 'DELETE_BUNDLE',
  RESET = 'RESET'
}

export interface userVehicleBundleAction {
  modifiedTyp: Vehicle[],
  action: TypAction
}

const logsloadtruck = "logs load truck";
const containertruck = "container truck";

@Injectable({
  providedIn: 'root',
})
export class TypificationdatashareService {
  _eventID$ = new BehaviorSubject<string>('');
  _eventImage$ = new BehaviorSubject<string>('');
  _plate$ = new BehaviorSubject<string>('');
  _withCrane$ = new BehaviorSubject<boolean>(false);
  _vehicleBunde$ = new BehaviorSubject<userVehicleBundleAction>
    ({
      modifiedTyp: [],
      action: TypAction.SET
    });
  _systemTypConfig$ = new BehaviorSubject<Object>('');

  vehicleBundeOriginal = new Array<Vehicle>();
  vehicleBundeActual = new Array<Vehicle>();


  private _eventID: string;
  private laserImage: string;
  private active: boolean = false;
  private _WdtkEvent: WdtkEvent = undefined;
  private truckClassification: string;

  constructor(private configService: ConfigService,) { }

  setId(importedEventId) {
    this._eventID = importedEventId;
    this._eventID$.next(importedEventId);
  }

  setImageURL(importedImageURL: string) {
    let finalImageUrl = importedImageURL;
    if (finalImageUrl.startsWith('/local_dataset_images')) {
      finalImageUrl = `${this.configService.loatWebBackend}${importedImageURL}`;
    }
    this.laserImage = finalImageUrl;
    this._eventImage$.next(finalImageUrl);
  }

  setPlate(importedPlate) {
    this._plate$.next(importedPlate);
  }

  setVehicleBundle(importVehicleBundle: Vehicle[]) {
    this.active = true;
    this.vehicleBundeOriginal = JSON.parse(JSON.stringify(importVehicleBundle));
    this.vehicleBundeActual = JSON.parse(JSON.stringify(importVehicleBundle));
    this._vehicleBunde$.next({ modifiedTyp: this.vehicleBundeActual, action: TypAction.SET });
  }

  setTypConfig(TYP_CONFIG) {
    this._systemTypConfig$.next(TYP_CONFIG);
  }

  setWdtkEvent(importedWdtkEvent: WdtkEvent) {
    //console.log(importedWdtkEvent);
    this._WdtkEvent = importedWdtkEvent;
    for (let data of importedWdtkEvent.lm_data.main.params.param) {
      if (data.name == 'event_id') {
        this.setId(data.value);
      }
      if (data.name == 'truck_id') {
        this.setPlate(data.value);
      }
      if (data.name == 'truckClassification') {
        this.truckClassification = data.value;
      }
    }
  }

  get eventID$() {
    return this._eventID$.asObservable();
  }

  get eventImage$() {
    return this._eventImage$.asObservable();
  }

  get plate$() {
    return this._plate$.asObservable();
  }

  get withCrane$() {
    return this._withCrane$.asObservable();
  }

  /*
  get eventID(): string {
    return this._eventID;
  }
  */

  get wdtkEvent(): any {
    return this._WdtkEvent;
  }


  newVehicle() {
    if (this.truckClassification == logsloadtruck) {
      let importedVehicle;
      let importedBundle = { params: [], model: {} };
      try {
        importedVehicle = JSON.parse(
          JSON.stringify(
            this.vehicleBundeActual.find((vehicle) => Number(vehicle.order) == 2)
          )
        );
        importedBundle = importedVehicle.bundles.find(
          (bundle) => Number(bundle.id) == 1
        );
      } catch (error) {
        importedVehicle = { params: [] }; // Ensure importedVehicle is initialized
        importedBundle.params = [{ name: 'arrange', value: 'longitudinal' }];
        importedBundle.model = {
          type: '',
          data: [{ name: '', value: '', factor: '', unit: '' }],
        };
      }

      this.vehicleBundeActual.push({
        id: String(this.vehicleBundeActual.length + 1), // Add id property
        order: String(this.vehicleBundeActual.length + 1),
        type: 'trailer',
        params: importedVehicle.params,
        location_area: {
          data: [
            {
              name: 'innerInitialLimit',
              value: '',
              factor: '1',
              unit: 'mm',
            },
            {
              name: 'innerEndingLimit',
              value: '',
              factor: '1',
              unit: 'mm',
            },
          ],
        },
        elements: { // Rename bundles to elements
          element: [
            {
              id: '1',
              type: 'area',
              params: { param: importedBundle.params },
              model: importedBundle.model,
              location_area: {
                data: [],
                data_array: []
              }
            },
          ],
        },
      });
    }


    if (this.truckClassification == containertruck) {
      let importedVehicle;
      let importedBundle = { params: [], model: {} };
      try {
        importedVehicle = JSON.parse(
          JSON.stringify(
            this.vehicleBundeActual.find((vehicle) => Number(vehicle.order) == 2)
          )
        );
        importedBundle = importedVehicle.bundles.find(
          (bundle) => Number(bundle.id) == 1
        );
      } catch (error) {
        importedVehicle = { params: [] }; // Ensure importedVehicle is initialized
        importedBundle.params = [{ name: 'arrange', value: 'chips' }];
        importedBundle.model = {
          type: 'unknown'
        };
      }

      this.vehicleBundeActual.push({
        //id: String(this.vehicleBundeActual.length + 1), 
        id: "", // en Contenedores el id o pantente debe ser ingresado por el usuario
        order: String(this.vehicleBundeActual.length + 1),
        type: 'trailer',
        params: importedVehicle.params,
        location_area: {
          data: [
            {
              name: 'innerInitialLimit',
              value: '',
              factor: '1',
              unit: 'mm',
            },
            {
              name: 'innerEndingLimit',
              value: '',
              factor: '1',
              unit: 'mm',
            },
          ],
        },
        elements: { // Rename bundles to elements
          element: [
            {
              id: '1',
              type: 'area',
              params: { param: importedBundle.params },
              model: importedBundle.model,
              location_area: {
                data: [],
                data_array: []
              }
            },
          ],
        },
      });
    }

    this._vehicleBunde$.next({ modifiedTyp: this.vehicleBundeActual, action: TypAction.NEW_VEHICLE });
  }

  newBundle(vehicleIndex: number) {
    if (this.truckClassification == logsloadtruck) {
      // Copy without reference
      let importedBundle = { params: [], model: {} };

      try {
        const importedVehicle = JSON.parse(
          JSON.stringify(
            this.vehicleBundeActual.find((vehicle) => Number(vehicle.order) == 2)
          )
        );
        importedBundle = importedVehicle.elements.find(
          (bundle) => Number(bundle.id) == 1
        );
      } catch (error) {
        importedBundle.params = [{ name: 'arrange', value: 'longitudinal' }];
        importedBundle.model = {
          type: '',
          data: [{ name: '', value: '', factor: '', unit: '' }],
        };
      }

      this.vehicleBundeActual[vehicleIndex].elements.element.push({
        id: String(this.vehicleBundeActual[vehicleIndex].elements.element.length + 1),
        type: 'area',
        params: { param: importedBundle.params }, // Wrap params in an object
        model: importedBundle.model,
        location_area: {
          data: [],
          data_array: [],
        },
      });
    }

    if (this.truckClassification == containertruck) {
      let importedBundle = { params: [], model: {} };

      try {
        const importedVehicle = JSON.parse(
          JSON.stringify(
            this.vehicleBundeActual.find((vehicle) => Number(vehicle.order) == 2)
          )
        );
        importedBundle = importedVehicle.elements.find(
          (bundle) => Number(bundle.id) == 1
        );
      } catch (error) {
        importedBundle.params = [{ name: 'arrange', value: 'chips' }];
        importedBundle.model = {
          type: 'unknown'
        };
      }

      this.vehicleBundeActual[vehicleIndex].elements.element.push({
        id: String(this.vehicleBundeActual[vehicleIndex].elements.element.length + 1),
        type: 'area',
        params: { param: importedBundle.params }, // Wrap params in an object
        model: importedBundle.model,
        location_area: {
          data: [],
          data_array: [],
        },
      });
    }

    this._vehicleBunde$.next({ modifiedTyp: this.vehicleBundeActual, action: TypAction.NEW_BUNDLE });
  }

  deleteVehicle(vehIndex: number) {
    if (vehIndex < 0 || vehIndex >= this.vehicleBundeActual.length) {
      console.error('Invalid vehicle index:', vehIndex);
      return;
    }

    // Remove the vehicle at the specified index
    this.vehicleBundeActual.splice(vehIndex, 1);

    // Update the order and id properties of the remaining vehicles
    for (let i = 0; i < this.vehicleBundeActual.length; i++) {
      this.vehicleBundeActual[i].order = String(i + 1);
      //this.vehicleBundeActual[i].id = String(i + 1); // Ensure id matches the new order
    }

    // Emit the updated vehicle bundle
    this._vehicleBunde$.next({ modifiedTyp: this.vehicleBundeActual, action: TypAction.DELETE_VEHICLE });
  }

  deleteBundle(vehicleIndex: number, bundleIndex: number) {
    if (
      vehicleIndex < 0 ||
      vehicleIndex >= this.vehicleBundeActual.length ||
      bundleIndex < 0 ||
      bundleIndex >= this.vehicleBundeActual[vehicleIndex].elements.element.length
    ) {
      console.error('Invalid vehicle or bundle index:', vehicleIndex, bundleIndex);
      return;
    }

    // Remove the bundle at the specified index
    this.vehicleBundeActual[vehicleIndex].elements.element.splice(bundleIndex, 1);

    // Update the id properties of the remaining bundles
    for (
      let i = 0;
      i < this.vehicleBundeActual[vehicleIndex].elements.element.length;
      i++
    ) {
      this.vehicleBundeActual[vehicleIndex].elements.element[i].id = String(i + 1);
    }

    // Emit the updated vehicle bundle
    this._vehicleBunde$.next({ modifiedTyp: this.vehicleBundeActual, action: TypAction.DELETE_BUNDLE });
  }

  resetTyp() {
    this.vehicleBundeActual = JSON.parse(
      JSON.stringify(this.vehicleBundeOriginal)
    );
    this._vehicleBunde$.next({ modifiedTyp: this.vehicleBundeActual, action: TypAction.RESET });
  }

  saveTyp(vehicleBunde: Vehicle[]) {
    /*this.finalPlate = plate;
    this.finalVehicleBunde = vehicleBunde;
    let obj = {
      "id_event": this.finalEventID,
      "eventPlate" : this.finalPlate,
      "vehicles": this.finalVehicleBunde
    }
    */
    let obj = {
      id_event: this._eventID,
      truckClassification: this.truckClassification,
      typification: vehicleBunde,
    };

    this.active = false;
    return obj;
  }

  public isActive() {
    return this.active;
  }

  getVehiclePlateByOrder(order: number): string {

    //const vehicles = this._WdtkEvent?.lm_data?.main?.vehicles?.vehicle || [];

    const vehicles = this.vehicleBundeActual;

    const vehicle = vehicles.find(v => Number(v.order) === order);

    return vehicle?.id || '';

  }

  updateVehicleBundle(vehicleBunde: Vehicle[]) {
    this.vehicleBundeActual = vehicleBunde;

    this._vehicleBunde$.next({
      modifiedTyp: this.vehicleBundeActual,
      action: TypAction.SET
    });
  }
}
